import { useEffect, useState } from "react";
import { Download, Share2 } from "lucide-react";
import { isIOS, isStandalone } from "@/lib/pwa";

/** Botón discreto "Instalar aplicación" -- Prompt Emergent Y, CAMBIO 3.
 * En Android/Chrome usa el evento beforeinstallprompt. En iPhone (sin ese
 * evento) muestra la instrucción de agregar a pantalla de inicio. */
export function InstallPwaButton() {
  const [deferredEvent, setDeferredEvent] = useState(null);
  const [installed, setInstalled] = useState(isStandalone());
  const [showIosHint, setShowIosHint] = useState(false);

  useEffect(() => {
    const onBip = (e) => { e.preventDefault(); setDeferredEvent(e); };
    const onInstalled = () => setInstalled(true);
    window.addEventListener("beforeinstallprompt", onBip);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onBip);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed) return null;
  if (!deferredEvent && !isIOS()) return null;

  const onClick = async () => {
    if (deferredEvent) {
      deferredEvent.prompt();
      const choice = await deferredEvent.userChoice;
      if (choice) setDeferredEvent(null);
      return;
    }
    setShowIosHint((v) => !v);
  };

  return (
    <div style={{ marginBottom: 12 }} data-testid="install-pwa-zone">
      <button type="button" onClick={onClick} className="btn-ghost" style={{ fontSize: 11, padding: "8px 12px" }} data-testid="install-pwa-button">
        <Download size={13} style={{ marginRight: 6 }} />Instalar aplicación
      </button>
      {showIosHint && (
        <div style={{ marginTop: 8, maxWidth: 420, fontSize: 12, background: "var(--invict-bone-2)", border: "1.5px dashed var(--invict-bone-3)", padding: 10, borderRadius: 2, color: "#0A0A0A" }} data-testid="install-pwa-ios-hint">
          <Share2 size={12} style={{ marginRight: 4, display: "inline", verticalAlign: "text-top" }} />
          En iPhone: tocá <b>Compartir → Agregar a pantalla de inicio</b>. Las notificaciones de SOS solo llegan si instalás la app así (iOS 16.4 o superior).
        </div>
      )}
    </div>
  );
}
